import { useEffect } from 'react'
import { App } from '@capacitor/app'
import { useNavigate } from 'react-router'

const useCapacitorBack = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const listener_promise = App.addListener('backButton', () => {
      if (window.history.length > 1) {
        navigate(-1)
      } else {
        App.exitApp()
      }
    })
    return ()=> {
      listener_promise.then(l=> { l.remove() })
    }
  }, [navigate])
}
export default useCapacitorBack